module.exports = __webpack_public_path__ + "static/media/pipe-green2.a448ee27.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/res/pipe-green2.png
 ** module id = 185
 ** module chunks = 0
 **/